class Installer {
    public installerId?: string;
    public businessName?: string;
    public address?: string;
    public contacts?: any;
    public geoCoord?: any[] | undefined;
    public residenceGeoCoord: any[] | undefined;

    constructor(installerId?: string, businessName?: string, address?: string, contacts?: any, geoCoord?: any[]) {
        this.installerId = installerId || undefined;
        this.businessName = businessName || undefined;
        this.address = address || undefined;
        this.contacts = contacts || undefined;
        this.geoCoord = geoCoord || undefined;
        this.contacts = contacts || undefined;
    }
}

export default Installer;
